<template>
  <el-dialog
    custom-class="import-dialog"
    title="营销活动"
    :visible="visible"
    @close="close"
  >
    <div class="p20">
      <div class="flex flex-between item-center">
      <div class="table-panel flex flex-end">
        <el-select
            clearable
            class="mr10"
            size="small"
            filterable
            v-model="gameType"
            visible-change="otherActivity"
            placeholder="请选择活动类型"
            @change="otherActivity"
        >
          <el-option
              :label="v.gameName"
              :value="v.gameCode"
              :key="i"
              v-for="(v, i) in gameTypeList"
          ></el-option>
        </el-select>
        <el-input
          class="mr10"
          size="small"
          v-model="gameName"
          placeholder="请输入名称"
          clearable     
        ></el-input>        
        <el-button size="small" type="primary" @click="search">查询</el-button>
      </div>
      </div>
      <div class="table-wrapper">
        <div class="tips mb20">提示：点击表格行即可选择</div>
        <el-table
          @current-change="getCheckedEmployee"
          highlight-current-row
          :data="goodsList"
          key="goodsList"
          style="width: 100%"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="(index) => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="活动类型"
            prop="gameType"
          >
            <template slot-scope="scope">
              {{ scope.row.gameType === "turntable" ? "大转盘" : "" }}
              {{ scope.row.gameType === "seckill" ? "秒杀" : "" }}
              {{ scope.row.gameType === "bargain" ? "砍价" : "" }}
              {{ scope.row.gameType === "bargains_team" ? "特价团" : "" }}
              {{ scope.row.gameType === "lottery_team" ? "抽奖团" : "" }}
              {{ scope.row.gameType === "collect_card" ? "集卡" : "" }}
              {{ scope.row.gameType === "leader_free_team" ? "团长免单团" : "" }}
              {{ scope.row.gameType === "integral_exchange" ? "积分兑换" : "" }}
              {{ scope.row.gameType === "single_single_exclusive" ? "单人单次专享" : ""}}
              {{ scope.row.gameType === "lucky_charm" ? "锦鲤活动" : "" }}
              {{ scope.row.gameType === "combination_set" ? "组合套餐活动" : "" }}
              {{ scope.row.gameType === "help_coupon" ? "助力劵" : "" }}
              {{ scope.row.gameType === "save_money_card" ? "省钱卡" : "" }}
              {{ scope.row.gameType === "password" ? "口令红包" : "" }}
              {{ scope.row.gameType === "red_envelope_rain" ? "红包雨" : "" }}
              {{ scope.row.gameType === "jielong" ? "接龙" : "" }}
              {{ scope.row.gameType === "subscribe" ? "预约活动" : "" }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="gameName"
            label="活动名称"
          ></el-table-column>
          <!-- <el-table-column
            header-align="center"
            align="center"
            prop="goodsNum"
            label="商品数量"
          ></el-table-column> -->
          <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="创建时间"
            width="150"
          ></el-table-column>
          <el-table-column
            width="280"
            header-align="center"
            align="center"
            prop="createTime"
            label="活动时间"
          >
            <template slot-scope="scope">
              {{ scope.row.gameStartTime }}至{{ scope.row.gameEndTime }}
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="goodsListTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      </div>
      <div class="btn-wrapper mb20 flex flex-center" style="padding-bottom:20px">
        <el-button size="small" type="primary" @click="save">确 定</el-button>
        <el-button size="small" @click="close">取 消</el-button>
      </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  props: {
    title: {
      type: String,
      default: "",
    },
    visible: {
      type: Boolean,
      default: false,
    }
  },
  components: {},
  data() {
    return {
      gameName: "",
      goodsList: [],
      goodsListTotal: 0,
      currentPage: 1,
      pageSize: 10,
      currentRow: {},
      gameType:"subscribe",
      allGoodsList: [], // 存储全部数据用于前端分页
    };
  },
  computed: mapGetters(["gameTypeList","subActivityList"]),
  watch: {
  },
  created() {},
  mounted() {
    this.queryGoodsList();
  },
  methods: {
    // 前端分页逻辑提取
    applyFrontendPagination() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      this.goodsList = this.allGoodsList.slice(start, end);
    },
    // 预约活动字段映射
    mapSubscribeItem(item) {
      return {
        ...item,
        gameId: item.id,
        gameName: item.actName,
        gameStartTime: item.applyStartTime,
        gameEndTime: item.applyEndTime,
        gameType: 'subscribe'
      };
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      if (!this.gameType) {
        this.applyFrontendPagination();
      } else {
        this.queryGoodsList();
      }
    },
    getCheckedEmployee(selection) {
      this.currentRow = selection;
      console.log("this.currentRow:",this.currentRow);
    },
    save() {
      if (!this.currentRow.gameId) {
        this.$message({
          type: "warning",
          message: "请先选择热销活动商品",
        });
      } else {
        let url = "";
        switch (this.currentRow.gameType) {
          case 'turntable': //大转盘
            url = `/activity/turnTable/turnTable`
            break;
          case 'seckill': //秒杀
            url = `/activity/seckill/seckill?gameId=${this.currentRow.gameId}`
            break;
          case 'bargain': //砍价
            url = `/activity/bargain/bargain?gameId=${this.currentRow.gameId}`
            break;
          case 'collect_card': //集卡
            url = `/activity/collectCard/collectCard`
            break;  
          case 'integral_exchange': //单人单次专享
            url = `/activity/integral/integralIndex?gameId=${this.currentRow.gameId}`
            break;
          case 'single_single_exclusive': //积分兑换
            url= `/activity/single/singleActivityList?gameId=${this.currentRow.gameId}`
            break;
          case 'bargains_team': //特价团
            url= `/activity/groupBuying/groupBuying?gameId=${this.currentRow.gameId}`
            break;
          case 'lottery_team': //抽奖团
            url= `/activity/groupBuying/groupBuying?gameId=${this.currentRow.gameId}`
            break;
          case 'leader_free_team': //团长免单团
            url= `/activity/groupBuying/groupBuying?gameId=${this.currentRow.gameId}`
            break;    
          case 'lucky_charm': //锦鲤活动
            url= `/activity/luckyOne/luckyOne?gameId=${this.currentRow.gameId}&gameShareContent=${this.currentRow.gameShareContent}`
            break;
          case 'combination_set': //组合套餐活动
            url= `/activity/shopList/index?gameId=${this.currentRow.gameId}`
            break;
          case 'help_coupon': //助力劵
            url= `/activity/powerStamps/powerStamps?gameId=${this.currentRow.gameId}`
            break;
          case 'save_money_card': //省钱卡
            url= `/activity/saveMoney/saveMoney?gameId=${this.currentRow.gameId}`
            break;
          case 'password': //口令红包
            url= `/activity/passwordRedEnvelope/passwordRedEnvelope`
            break;  
          case 'red_envelope_rain': //红包雨
            url= `/activity/redEnvelopeRain/redEnvelopeRain`
          case 'jielong': //接龙
            url= `/activity/jieLong/infor?gameId=${this.currentRow.gameId}`  
            break;
          case 'subscribe': //预约活动
            url= `/activity/reservation/activityDetails?id=${this.currentRow.gameId}`
            break;
          default:
            break;
        }
        this.currentRow.url = url;
        console.log("this.currentRow.url:",this.currentRow.url);
        this.$emit("saveActivityCenter", this.currentRow);
      }
    },
    close() {
      this.$emit("close");
    },
    paging(page) {
      this.currentPage = page;
      if (!this.gameType) {
        this.applyFrontendPagination();
      } else {
        this.queryGoodsList(false);
      }
    },
    async queryGoodsList(resetPage = true) {
      console.log("HmFilterActivityCenter");
      // 重置页码（默认重置，分页方法调用时传入 false）
      if (resetPage) {
        this.currentPage = 1;
      }
      // 预约活动调用单独接口
      if (this.gameType === 'subscribe') {
        const params = {
          pageSize: this.pageSize,
          pageNo: this.currentPage,
          actName: this.gameName,
          timeStatus: "all"
        };
        const { result } = await this.$store.dispatch("subActivityList", params);
        // 字段映射：统一数据格式
        const { activityList } = result;
        const { records, total } = activityList;
        this.goodsList = records.map(this.mapSubscribeItem);
        this.goodsListTotal = total;
      } else if (!this.gameType) {
        // 未选择类型时，合并两个接口数据，前端分页
        // 先获取第一页数据，如果总数大于页大小，需要获取更多数据
        const [activityResult, subResult] = await Promise.all([
          this.$store.dispatch("filterMyActivityList", {
            pageSize: 9999, // 获取较多数据
            pageNo: 1,
            keyWords: this.gameName,
            gameType: this.gameType,
            enabledState: "yes",
          }),
          this.$store.dispatch("subActivityList", {
            pageSize: 9999, // 获取较多数据
            pageNo: 1,
            actName: this.gameName,
            timeStatus: "all"
          })
        ]);
        // 处理原接口数据
        const { pageList } = activityResult.result;
        const activityRecords = pageList.records;
        // 处理预约活动数据并做字段映射
        const subRecords = subResult.result.activityList.records.map(this.mapSubscribeItem);
        // 合并全部数据
        this.allGoodsList = [...activityRecords, ...subRecords];
        this.goodsListTotal = this.allGoodsList.length;
        // 前端分页
        this.applyFrontendPagination();
      } else {
        // queryHotSaleGameList
        // filterMyActivityList
        const { result } = await this.$store.dispatch("filterMyActivityList", {
          pageSize: this.pageSize,
          pageNo: this.currentPage,
          keyWords: this.gameName,
          gameType: this.gameType,
          enabledState: "yes",
        });
        const { pageList } = result;
        const { records, total } = pageList;
        // const { records, total } = result;
        this.goodsList = records;
        console.log("this.goodsList:",this.goodsList);
        this.goodsListTotal = total;
      }
      if(this.gameTypeList.length>0){
        this.gameTypeList.forEach((v,i) => {
          if(v.gameCode=='otherGame'){
            console.log(v.gameName)
            this.gameTypeList.splice(i, 1);
          }
        });
        this.gameTypeList.forEach((v,i) => {
          if(v.gameCode=='collect_card'){
            console.log(v.gameName)
            this.gameTypeList.splice(i, 1);
          }
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryGoodsList();
    },
    otherActivity(){
      console.log(this.gameType);
      this.currentPage = 1;
      this.queryGoodsList();
    },
  },
};
</script>
<style lang="scss" scoped></style>
